"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var background_description_enum_1 = __importDefault(require("../../shared/enums/background-description.enum"));
var assetImport_1 = __importDefault(require("../../shared/utilities/assetImport"));
var classMap_1 = __importDefault(require("../../shared/utilities/classMap"));
function Background(props) {
    var theme = props.theme, className = props.className, size = props.size, background = props.background;
    var bgName = background.split("/")[1];
    var backgroundName = bgName.split(".")[0].replace("-", "_").toUpperCase();
    return (react_1.default.createElement("div", { role: "banner", "aria-label": background_description_enum_1.default[backgroundName], className: (0, classMap_1.default)("mpng-ux-background", "position-contain background-cover", className, "size landscape", size), style: {
            backgroundImage: "url(".concat((0, assetImport_1.default)(background, theme), ")")
        } }));
}
exports.default = Background;
